// Copyright 2005-2011 David Caldwell <david@greenfelt.net> All rights reserved.

var klondike = require('./klondike');
var solitaire = require('./solitaire').games;
var piles = require('./piles'), up=piles.up, down=piles.down;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;

solitaire.yukon = class extends klondike {
    static variants = { }; // Have to override klondike's variants.

    create_deck() { this.deck = this.play = {} } // no deck in yukon

    static work_pile = class extends klondike.work_pile {
        maxstack = Math.ceil(18.2765873015873); // Determined by query in upgrades/maxstack.sql
    }

    deal(deck) {
        super.deal(deck);
        var c, p = 0;
        while (deck.length) {
            this.work[p++ % 6 + 1].push(c = deck.pop());
            c.face = up;
        }
    }

    complete() {
        return this.complete_generic(this.good, [this.work]);
    }

    layout = grid(["good1", "good2", "good3", "good4", undefined, undefined, undefined],
                  ["work1", "work2", "work3", "work4", "work5", "work6", "work7"]);
}

module.exports = solitaire.yukon;
// Copyright 2005-2011 David Caldwell <david@greenfelt.net> All rights reserved.

var klondike = require('./klondike');
var solitaire = require('./solitaire').games;
var piles = require('./piles'), up=piles.up, down=piles.down;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;

solitaire.yukon = class extends klondike {
    static variants = { }; // Have to override klondike's variants.

    create_deck() { this.deck = this.play = {} } // no deck in yukon

    static work_pile = class extends klondike.work_pile {
        maxstack = Math.ceil(18.2765873015873); // Determined by query in upgrades/maxstack.sql
    }

    deal(deck) {
        super.deal(deck);
        var c, p = 0;
        while (deck.length) {
            this.work[p++ % 6 + 1].push(c = deck.pop());
            c.face = up;
        }
    }

    complete() {
        return this.complete_generic(this.good, [this.work]);
    }

    layout = grid(["good1", "good2", "good3", "good4", undefined, undefined, undefined],
                  ["work1", "work2", "work3", "work4", "work5", "work6", "work7"]);
}

module.exports = solitaire.yukon;
